module.exports = __webpack_public_path__ + "img/de-praktijk-3.e3e1076b.jpg";